module.exports = __webpack_public_path__ + "static/klimaatverandering-extreme-buien-nederland-mobile-43923fb835b88438ec111de00b27a1f0.jpg";